<div class="flex flex-col px-1 h-full">
	<div class="text-2xl mb-8 mt-4 font-bold">Invite Colleagues</div>

	<form
		class="flex flex-col flex-1 text-sm justify-between"
		(ngSubmit)="sendInvites()"
	>
		<app-pill-input
			[autofocus]="true"
			placeholder="Type or paste emails separated by a comma"
			[disabled]="sendState === SendStates.SENDING"
			[formControl]="inviteControl"
			[validatorFn]="emailValidator"
			(onTextInput)="onTextInput()"
			label="Add Your Colleagues (optional)"
		></app-pill-input>

		<div class="flex justify-end gap-4 items-end">
			<ui-button
				class="self-end mt-8"
				(click)="_onBack()"
				preset="LOW_EMPHASIS"
				icon="chevron-left"
				[disabled]="sendState === SendStates.SENDING"
				label="Back"
			></ui-button>
			<ui-button
				type="submit"
				class="self-end"
				btn="primary"
				[loading]="sendState === SendStates.SENDING"
				preset="HIGH_EMPHASIS"
				size="md"
				label="Complete Setup"
			></ui-button>
		</div>
	</form>
	<div></div>
</div>
